"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validate = void 0;
exports.validate = function (data) {
    if (!data.appName)
        throw Error('invalid data tracking data: missing "app name"');
    if (!data.action)
        throw Error('invalid data tracking data: missing "data action"');
    if (!data.type)
        throw Error('invalid data tracking data: missing "data type"');
    if (typeof data.items !== 'undefined') {
        if (Array.isArray(data.items)) {
            data.items.forEach(function (item) {
                if (Object.keys(item).length !== 2)
                    throw Error('invalid data tracking data: missing "data items must be a list of key-value pairs"');
            });
        }
        else
            throw Error('invalid data tracking data: missing "data items"');
    }
    return true;
};
var dispatchTrackingEvent = function (data) {
    if (Object.keys(data).length > 0) {
        // validate
        exports.validate(data);
        // dispatch event
        if (window.topContext) {
            window.topContext.hybridAppEventBus.publish(data.type.join(','), data);
        }
        else {
            // tslint:disable-next-line:no-console
            console.log('c9-tracking event missing event bus', data);
        }
    }
};
exports.default = dispatchTrackingEvent;
